var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0199 2.20147C16.1783 0.819133 13.8896 0 11.4115 0C5.33246 0 0.397461 4.92873 0.397461 11C0.397461 17.0713 5.33246 22 11.4115 22C17.2056 22 21.9599 17.5215 22.3931 11.8448C22.4548 11.0374 21.8491 10.3327 21.0406 10.2711C20.2322 10.2095 19.5266 10.8145 19.4649 11.6219C19.1469 15.7843 15.6599 19.0667 11.4115 19.0667C6.95372 19.0667 3.33453 15.4521 3.33453 11C3.33453 6.54793 6.95372 2.93333 11.4115 2.93333C13.1385 2.93333 14.7399 3.476 16.0535 4.4H15.0828C14.2722 4.4 13.6143 5.05707 13.6143 5.86667C13.6143 6.67627 14.2722 7.33333 15.0828 7.33333H19.4884C20.2997 7.33333 20.9569 6.677 20.9569 5.86667V1.46667C20.9569 0.657067 20.299 0 19.4884 0C18.6778 0 18.0199 0.657067 18.0199 1.46667V2.20147Z",
    fill: "#424242",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.53ddf6e4c30d9d964c9773603eab4bf0.svg";
export { ForwardRef as ReactComponent };